export default __webpack_public_path__ + "static/media/Sort.0879a5e5.svg";